import { Component, OnInit, inject } from '@angular/core';
import { VersionService } from 'src/app/core/services/version.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-version-mismatch-alert',
  templateUrl: './version-mismatch-alert.component.html',
  styleUrls: ['./version-mismatch-alert.component.scss']
})
export class VersionMismatchAlertComponent implements OnInit {
  showAlert = false;
  currentVersion = environment.version;
  private versionService = inject(VersionService);

  ngOnInit(): void {
    this.versionService.shouldShowMismatchAlert().subscribe(show => {
      this.showAlert = show;
    });
  }

  dismissAlert(): void {
    this.versionService.dismissMismatchAlert();
    this.showAlert = false;
  }

  reloadPage(): void {
    window.location.href = window.location.href + '?cachedate=' + Date.now();
  }
}
